export default "__VITE_ASSET__BvDygbaB__"